<template>
  <component
    :is="tag"
    :class="dropdownParent ? 'mm-dropdown-item' : 'mm-dropdown'">
    <div
      v-if="button"
      ref="reference">
      <ui-button-group :disabled="disabled">
        <ui-button
          :type="type"
          :native-type="nativeType"
          :size="size"
          :disabled="disabledButton"
          @click="buttonClick">
          <slot></slot>
        </ui-button>
        <ui-button
          :type="type"
          :icon="icon"
          :size="size"
          :disabled="disabledDropdown"
          @click="localVisible = !localVisible"></ui-button>
      </ui-button-group>
    </div>

    <div
      v-else
      ref="reference"
      class="mm-dropdown-trigger"
      @click="localVisible = !localVisible">
      <slot :visible="localVisible"></slot>
    </div>

    <ui-popper
      :visible.sync="localVisible"
      v-bind="$props"
      :transition="transition"
      class="mm-dropdown-popper"
      target="reference"
      @after-enter="$emit('after-enter')"
      @after-leave="$emit('after-leave')">
      <slot name="dropdown"></slot>
    </ui-popper>
  </component>
</template>

<script>
import omit from "lodash/omit"
import visible from "../../mixins/visible"
import Popper from "../popper"
import ButtonGroup from "../button-group"
import Button from "../button"
import config from "../../managers/config"

config.defaults({
  "Dropdown.visibleArrow": false,
  "Dropdown.hideOnClick": true,
})

export default {
  name: "mm-dropdown",
  components: {
    "ui-popper": Popper,
    "ui-button-group": ButtonGroup,
    "ui-button": Button,
  },
  mixins: [visible],
  inheritAttrs: false,
  provide() {
    return {
      "mm-dropdown": this,
    }
  },
  inject: {
    dropdownParent: {
      from: "mm-dropdown",
      default: null,
    },
  },
  props: {
    ...omit(Popper.props, ["visible", "target", "trigger", "placement", "trackRefWidth"]),
    transition: {
      type: String,
      default: "zoom-in-top",
    },

    visibleArrow: {
      type: Boolean,
      default: () => config.get("Dropdown.visibleArrow"),
    },

    hideOnClick: {
      type: Boolean,
      default() {
        return this.dropdownParent ? this.dropdownParent.hideOnClick : config.get("Dropdown.hideOnClick")
      },
    },
    // buttonify
    button: {
      type: Boolean,
      default: false,
    },
    buttonClick: {
      type: Function,
      default() {},
    },
    size: {
      type: String,
    },
    icon: {
      type: String,
      default: "switch",
    },
    nativeType: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      default: () => {},
    },
    type: {
      type: String,
    },
    placement: {
      type: String,
      default() {
        return this.button ? "bottom-end" : "bottom-start"
      },
    },
    disabledDropdown: {
      type: Boolean,
      default: false,
    },
    disabledButton: {
      type: Boolean,
      default: false,
    },
    trackRefWidth: {
      type: Boolean,
      default() {
        return this.button
      },
    },
  },
  data() {
    return {
      isDropdown: true,
    }
  },
  computed: {
    tag() {
      return this.dropdownParent ? "li" : "div"
    },
  },
  watch: {
    localVisible(value) {
      this.$emit("visible-change", value)
    },
  },
  created() {
    this.$on("item-click", this.handleItemClick)
  },
  methods: {
    handleItemClick(event, item) {
      this.$emit("click", event, item.name, item)
      this.onClick(event, item.name, item)

      if (this.hideOnClick) {
        this.hide()

        if (this.dropdownParent && this.dropdownParent.hideOnClick) {
          this.dropdownParent.$emit("item-click", event, item)
        }
      }
    },
  },
}
</script>
